<template>
  <div class="add-items">
    <v-menu open-on-hover top offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" fab>
          <v-icon dark>add</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="addDataType">
          <v-list-item-title>Data Type</v-list-item-title>
        </v-list-item>
        <v-list-item @click="addFunction">
          <v-list-item-title>Function</v-list-item-title>
        </v-list-item>
        <v-list-item @click="addFunctionBlock">
          <v-list-item-title>Function Block</v-list-item-title>
        </v-list-item>
        <v-list-item @click="addProgram">
          <v-list-item-title>Program</v-list-item-title>
        </v-list-item>
        <v-list-item @click="addResource">
          <v-list-item-title>Resource</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <component :is="componentName"></component>
  </div>
</template>

<script>
import AddPou from "./AddPou";
import AddResource from "./AddResource";
import AddDataType from "./AddDataType";

export default {
  name: "AddItems",
  components: { AddPou, AddResource, AddDataType },
  computed: {
    componentName() {
      return this.$store.state.addItem.componentName;
    },
  },
  methods: {
    addDataType() {
      this.$store.dispatch("updateAddItem", {
        componentName: "AddDataType",
        itemTempId: undefined,
        showDialog: true,
      });
    },
    addProgram() {
      this.$store.dispatch("updateAddItem", {
        componentName: "AddPou",
        itemTempId: undefined,
        showDialog: true,
        pouType: "program",
      });
    },
    addFunction() {
      this.$store.dispatch("updateAddItem", {
        componentName: "AddPou",
        itemTempId: undefined,
        showDialog: true,
        pouType: "function",
      });
    },
    addFunctionBlock() {
      this.$store.dispatch("updateAddItem", {
        componentName: "AddPou",
        itemTempId: undefined,
        showDialog: true,
        pouType: "functionBlock",
      });
    },
    addResource() {
      this.$store.dispatch("updateAddItem", {
        componentName: "AddResource",
        itemTempId: undefined,
        showDialog: true,
      });
    },
  },
};
</script>

<style scoped>
.add-items {
  position: absolute;
  top: 5px;
  right: 5px;
}
</style>
